import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { wellnub } from 'network/wellnub.api';
import { setNutritionistTestOptions } from '../state/nutritionist-test.slice';

export const queryFn = async () => {
  const { data } = await wellnub.get(`/v1/client/testFindNutritionist`);
  return data;
};

export const useGetNutritionistTestOptions = () => {
  const dispatch = useDispatch();

  return useQuery('GET_NUTRITIONIST_TEST_OPTIONS', queryFn, {
    onSuccess: data => {
      dispatch(setNutritionistTestOptions(data));
    },
  });
};
